module.exports = __webpack_public_path__ + "assets/54498d0ad4ecbe85db70a2d05295ddd6.svg";